// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown_markdown__1eWjC"};